import { Outlet } from "react-router-dom";
import BlueHeader from "@/components/organisms/blueHeader";
import LineArt from "@/assets/images/lineArt.png";

// for admin and consultant
export default function OverflowHome() {

    return (

        <div className="bg-lighter flex grow overflow-hidden relative">

            <div className="w-full h-[93vh] overflow-y-scroll overflow-x-hidden z-10  ">
            {/* <BlueHeader title="overflow.overflowAccount" /> */}

                <img src={LineArt} onDragStart={(e) => e.preventDefault()} className="bgLineArt " alt="Line Art Background" />
                <Outlet />

            </div>

        </div>
    )
}